import React from "react";
import Spinner from "react-spinkit";

const BubbleLoader = props => {
  return (
    <Spinner name="three-bounce" className="center-loader" color="#52bad5" fadeIn="none"/>
  );
};

export default BubbleLoader;
